var _defs, _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _rect, _rect2, _path0, _circle2, _path1, _path10, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0059_ui_design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    "data-imageid": "ui-design-26",
    imageName: "UI Design",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1_ui-design-26{fill:url(#linear-gradient-21-ui-design-26);}.cls-1_ui-design-26,.cls-2_ui-design-26,.cls-3_ui-design-26,.cls-4_ui-design-26,.cls-5_ui-design-26,.cls-6_ui-design-26,.cls-7_ui-design-26,.cls-8_ui-design-26,.cls-9_ui-design-26,.cls-10_ui-design-26,.cls-11_ui-design-26,.cls-12_ui-design-26,.cls-13_ui-design-26,.cls-14_ui-design-26,.cls-15_ui-design-26,.cls-16_ui-design-26,.cls-17_ui-design-26,.cls-18_ui-design-26,.cls-19_ui-design-26,.cls-20_ui-design-26,.cls-21_ui-design-26,.cls-22_ui-design-26,.cls-23_ui-design-26,.cls-24_ui-design-26,.cls-25_ui-design-26,.cls-26_ui-design-26,.cls-27_ui-design-26{stroke-width:0px;}.cls-1_ui-design-26,.cls-4_ui-design-26,.cls-23_ui-design-26{isolation:isolate;}.cls-1_ui-design-26,.cls-23_ui-design-26{opacity:.19;}.cls-2_ui-design-26{fill:none;}.cls-3_ui-design-26{fill:url(#linear-gradient);}.cls-4_ui-design-26{opacity:.18;}.cls-4_ui-design-26,.cls-27_ui-design-26{fill:#68e1fd;}.cls-5_ui-design-26{fill:url(#linear-gradient-11-ui-design-26);}.cls-6_ui-design-26{fill:url(#linear-gradient-12-ui-design-26);}.cls-7_ui-design-26{fill:url(#linear-gradient-13-ui-design-26);}.cls-8_ui-design-26{fill:url(#linear-gradient-10-ui-design-26);}.cls-9_ui-design-26{fill:url(#linear-gradient-17-ui-design-26);}.cls-10_ui-design-26{fill:url(#linear-gradient-16-ui-design-26);}.cls-11_ui-design-26{fill:url(#linear-gradient-19-ui-design-26);}.cls-12_ui-design-26{fill:url(#linear-gradient-15-ui-design-26);}.cls-13_ui-design-26{fill:url(#linear-gradient-18-ui-design-26);}.cls-14_ui-design-26{fill:url(#linear-gradient-14-ui-design-26);}.cls-15_ui-design-26{fill:url(#linear-gradient-20-ui-design-26);}.cls-16_ui-design-26{fill:url(#linear-gradient-4-ui-design-26);}.cls-17_ui-design-26{fill:url(#linear-gradient-3-ui-design-26);}.cls-18_ui-design-26{fill:url(#linear-gradient-8-ui-design-26);}.cls-19_ui-design-26{fill:url(#linear-gradient-9-ui-design-26);}.cls-20_ui-design-26{fill:url(#linear-gradient-7-ui-design-26);}.cls-21_ui-design-26{fill:url(#linear-gradient-5-ui-design-26);}.cls-22_ui-design-26{fill:url(#linear-gradient-6-ui-design-26);}.cls-23_ui-design-26{fill:url(#linear-gradient-2-ui-design-26);}.cls-24_ui-design-26{fill:#231f20;}.cls-25_ui-design-26{fill:#fff;}.cls-26_ui-design-26{fill:#ffaa71;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-ui-design-26",
    x1: 378.09,
    y1: -584.4,
    x2: 390.09,
    y2: -888.82,
    gradientTransform: "translate(-140.43 942.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-ui-design-26",
    x1: 287.34,
    y1: -748.26,
    x2: 483.79,
    y2: -748.26,
    gradientTransform: "translate(-140.43 942.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68e1fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3-ui-design-26",
    x1: 381.83,
    y1: -913.75,
    x2: 410.08,
    y2: -845.95,
    xlinkHref: "#linear-gradient-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4-ui-design-26",
    x1: 194.54,
    y1: -920.09,
    x2: 194.2,
    y2: -908.26,
    gradientTransform: "translate(-140.43 942.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7faff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5-ui-design-26",
    x1: 208.68,
    y1: -919.69,
    x2: 208.34,
    y2: -907.85,
    xlinkHref: "#linear-gradient-4-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6-ui-design-26",
    x1: 113.37,
    y1: -919.13,
    x2: 113.04,
    y2: -907.29,
    gradientTransform: "translate(-31 942.5)",
    xlinkHref: "#linear-gradient-4-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7-ui-design-26",
    x1: 290.95,
    y1: -867.68,
    x2: 249.02,
    y2: -860.92,
    gradientTransform: "translate(-140.43 942.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8-ui-design-26",
    x1: 296.84,
    y1: -831.2,
    x2: 254.91,
    y2: -824.44,
    xlinkHref: "#linear-gradient-7-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9-ui-design-26",
    x1: 302.72,
    y1: -794.73,
    x2: 260.79,
    y2: -787.97,
    xlinkHref: "#linear-gradient-7-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10-ui-design-26",
    x1: 308.61,
    y1: -758.23,
    x2: 266.68,
    y2: -751.46,
    xlinkHref: "#linear-gradient-7-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11-ui-design-26",
    x1: 525.82,
    y1: -768.92,
    x2: 336.53,
    y2: -771.75,
    gradientTransform: "translate(-31 942.5)",
    xlinkHref: "#linear-gradient-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12-ui-design-26",
    x1: 391.24,
    y1: -825.99,
    x2: 391.24,
    y2: -516.92,
    gradientTransform: "translate(-140.43 942.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13-ui-design-26",
    x1: 303.82,
    y1: -597.25,
    x2: 308.42,
    y2: -597.25,
    xlinkHref: "#linear-gradient-12-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14-ui-design-26",
    x1: 336.39,
    y1: -597.25,
    x2: 340.98,
    y2: -597.25,
    xlinkHref: "#linear-gradient-12-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15-ui-design-26",
    x1: 196.69,
    y1: -692.59,
    x2: 229.25,
    y2: -692.59,
    gradientTransform: "translate(-31 942.5)",
    xlinkHref: "#linear-gradient-12-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16-ui-design-26",
    x1: 196.69,
    y1: -658.92,
    x2: 229.25,
    y2: -658.92,
    gradientTransform: "translate(-31 942.5)",
    xlinkHref: "#linear-gradient-12-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17-ui-design-26",
    x1: 196.69,
    y1: -625.26,
    x2: 229.25,
    y2: -625.26,
    gradientTransform: "translate(-31 942.5)",
    xlinkHref: "#linear-gradient-12-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18-ui-design-26",
    x1: 196.69,
    y1: -591.58,
    x2: 229.25,
    y2: -591.58,
    gradientTransform: "translate(-31 942.5)",
    xlinkHref: "#linear-gradient-12-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19-ui-design-26",
    x1: 196.69,
    y1: -557.92,
    x2: 229.25,
    y2: -557.92,
    gradientTransform: "translate(-31 942.5)",
    xlinkHref: "#linear-gradient-12-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20-ui-design-26",
    x1: 196.69,
    y1: -524.25,
    x2: 229.25,
    y2: -524.25,
    gradientTransform: "translate(-31 942.5)",
    xlinkHref: "#linear-gradient-12-ui-design-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21-ui-design-26",
    x1: 298.79,
    y1: -763.01,
    x2: 322.37,
    y2: -763.01,
    xlinkHref: "#linear-gradient-2-ui-design-26"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4_ui-design-26 targetColor",
    d: "M122.9,370.72c-14.23,16.61-34.43,30.04-39.58,51.3-4.04,16.63,3.41,35.43,17.73,44.77,12.25,8.03,27.88,9.07,42.37,7.27,14.49-1.8,28.65-6.07,43.16-7.93,17.26-2.16,34.75-.76,52.11-1.69,17.36-.93,35.33-4.65,48.92-15.5,4.2-3.35,7.99-7.48,9.7-12.57,1.8-5.4,1.09-11.25,1.17-16.95.4-17.96,8.83-34.8,22.96-45.89,7.98-6.17,17.45-10.24,25.11-16.82,12.84-11.27,19.06-28.3,16.49-45.19-.97-5.98-131.2-.33-143.84.14-11.77.44-23.53.98-35.3,1.62-7.96.43-24.28-1.62-30.67,3.7-5.74,4.78-8.71,19.06-12.26,25.9-5.09,9.86-10.87,19.38-18.09,27.84Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "screen_ui-design-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27_ui-design-26 targetColor",
    d: "M456.62,41.02v255.19c0,10.65-8.62,19.29-19.27,19.3H52.93c-10.65,0-19.29-8.64-19.29-19.29h0V41.02c.03-10.64,8.65-19.25,19.29-19.26h384.42c10.63.02,19.24,8.63,19.27,19.26Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3_ui-design-26",
    d: "M456.62,41.02v255.19c0,10.65-8.62,19.29-19.27,19.3H52.93c-10.65,0-19.29-8.64-19.29-19.29h0V41.02c.03-10.64,8.65-19.25,19.29-19.26h384.42c10.63.02,19.24,8.63,19.27,19.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23_ui-design-26",
    d: "M153.22,73.36l-6.31,2.97v127.19l16.5,59.56,2.28,51.6,41.74.76v-88.96l17.25-25.51,118.69-.46v-6.61l-190.14-120.54ZM209.1,203.71c-1.67,3.79-5.22,7.35-7.7,10.67-3.04,4.09-6.12,8.16-9.25,12.23-.27.4-.63.75-1.03,1.02-1.46.83-3.16-.55-4.23-1.84-6.1-7.37-10.81-15.79-13.89-24.85-.21-.44-.24-.95-.1-1.42.31-.68,1.24-.76,2-.76,9.41.26,18.82.57,28.23.95,3.22.12,7.96-.57,5.97,3.98v.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27_ui-design-26 targetColor",
    d: "M457.89,40.95v3.79H34.9v-3.79c0-10.66,8.64-19.3,19.3-19.31h384.39c10.66,0,19.29,8.64,19.3,19.3h0Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27_ui-design-26 targetColor",
    d: "M457.89,40.95v3.79H34.9v-3.79c0-10.66,8.64-19.3,19.3-19.31h384.39c10.66,0,19.29,8.64,19.3,19.3h0Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17_ui-design-26",
    d: "M457.89,40.95v3.79H34.9v-3.79c0-10.66,8.64-19.3,19.3-19.31h384.39c10.66,0,19.29,8.64,19.3,19.3h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16_ui-design-26",
    d: "M56.84,33.21c0,1.68-1.36,3.04-3.04,3.04s-3.04-1.36-3.04-3.04,1.36-3.04,3.04-3.04,3.04,1.36,3.04,3.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21_ui-design-26",
    d: "M70.99,33.21c0,1.68-1.36,3.04-3.04,3.04s-3.04-1.36-3.04-3.04,1.36-3.04,3.04-3.04,3.04,1.36,3.04,3.04Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22_ui-design-26",
    cx: 82.1,
    cy: 33.2,
    r: 3.04
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27_ui-design-26 targetColor",
    d: "M126.28,44.76v270.68H54.18c-10.65,0-19.29-8.64-19.3-19.29V44.76h91.39Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20_ui-design-26",
    d: "M114.08,88.22H47.88c-1.12,0-2.02-.91-2.03-2.03h0c0-1.11.9-2.02,2.01-2.03h66.22c1.12,0,2.02.91,2.03,2.03h0c0,1.12-.91,2.02-2.03,2.03Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18_ui-design-26",
    d: "M114.08,125.65H47.88c-1.12,0-2.02-.91-2.03-2.03h0c0-1.12.9-2.03,2.02-2.03h66.21c1.12,0,2.03.91,2.03,2.03h0c0,1.12-.91,2.02-2.03,2.03Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19_ui-design-26",
    d: "M114.08,163.09H47.88c-1.12,0-2.02-.91-2.03-2.03h0c-.02-1.12.88-2.05,2-2.06,0,0,.02,0,.02,0h66.2c1.12,0,2.02.91,2.03,2.03h0c.02,1.12-.88,2.05-2,2.06,0,0-.02,0-.02,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8_ui-design-26",
    d: "M114.08,200.51H47.88c-1.11,0-2.02-.9-2.03-2.01h0c0-1.11.9-2.02,2.01-2.03h66.22c1.11,0,2.02.87,2.05,1.98h0c.01,1.12-.89,2.04-2.01,2.06-.01,0-.03,0-.04,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27_ui-design-26 targetColor",
    x: 281.99,
    y: 227.56,
    width: 68.51,
    height: 25.35,
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27_ui-design-26 targetColor",
    d: "M457.89,44.76v251.37c0,10.65-8.62,19.3-19.28,19.31h-64.03V44.76h83.31Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5_ui-design-26",
    x: 374.58,
    y: 116.16,
    width: 83.31,
    height: 112.49
  }))), /*#__PURE__*/React.createElement("g", {
    id: "image_ui-design-26"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25_ui-design-26",
    x: 153.21,
    y: 69.62,
    width: 194.85,
    height: 126.84
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27_ui-design-26 targetColor",
    x: 160.5,
    y: 76.31,
    width: 180.61,
    height: 113.45,
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6_ui-design-26",
    d: "M341.11,137.91v51.85h-180.61v-34.39c10.29-11.49,25.5-19.1,39.04-28.5,2.46-1.86,5.15-3.41,7.99-4.62,11.63-4.39,23.96,3.26,34.53,9.79,12.8,7.91,26.29,14.65,40.3,20.13-4.71-6.81-11.54-11.88-19.43-14.42l18.43-15.27c2.28-1.89,4.63-3.79,7.41-4.82,5.59-2,11.74.08,17.26,2.28,7.72,3.08,15.32,6.43,22.81,10.04,4.4,2.16,8.86,4.45,12.26,7.94Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-25_ui-design-26",
    cx: 314.96,
    cy: 98.36,
    r: 12.17
  }))), /*#__PURE__*/React.createElement("g", {
    id: "stair_ui-design-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27_ui-design-26 targetColor",
    d: "M165.68,463.22h0c1.26,0,2.28-1.02,2.28-2.28v-231.08c0-1.26-1.02-2.28-2.28-2.28h0c-1.26,0-2.28,1.02-2.28,2.28v231.06c0,1.26,1.02,2.28,2.28,2.28v.02Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27_ui-design-26 targetColor",
    d: "M198.25,463.22h0c1.26,0,2.28-1.02,2.28-2.28v-231.08c0-1.26-1.02-2.28-2.28-2.28h0c-1.26,0-2.28,1.02-2.28,2.28v231.06c0,1.26,1.02,2.28,2.28,2.28v.02Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27_ui-design-26 targetColor",
    x: 165.69,
    y: 247.29,
    width: 32.56,
    height: 5.24,
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27_ui-design-26 targetColor",
    x: 165.69,
    y: 280.96,
    width: 32.56,
    height: 5.24,
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27_ui-design-26 targetColor",
    x: 165.69,
    y: 314.62,
    width: 32.56,
    height: 5.24,
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27_ui-design-26 targetColor",
    x: 165.69,
    y: 348.29,
    width: 32.56,
    height: 5.24,
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27_ui-design-26 targetColor",
    x: 165.69,
    y: 381.96,
    width: 32.56,
    height: 5.24,
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27_ui-design-26 targetColor",
    x: 165.69,
    y: 415.63,
    width: 32.56,
    height: 5.24,
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7_ui-design-26",
    d: "M165.68,463.22h0c1.26,0,2.28-1.02,2.28-2.28v-231.08c0-1.26-1.02-2.28-2.28-2.28h0c-1.26,0-2.28,1.02-2.28,2.28v231.06c0,1.26,1.02,2.28,2.28,2.28v.02Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14_ui-design-26",
    d: "M198.25,463.22h0c1.26,0,2.28-1.02,2.28-2.28v-231.08c0-1.26-1.02-2.28-2.28-2.28h0c-1.26,0-2.28,1.02-2.28,2.28v231.06c0,1.26,1.02,2.28,2.28,2.28v.02Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12_ui-design-26",
    x: 165.69,
    y: 247.29,
    width: 32.56,
    height: 5.24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10_ui-design-26",
    x: 165.69,
    y: 280.96,
    width: 32.56,
    height: 5.24
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_ui-design-26",
    x: 165.69,
    y: 314.62,
    width: 32.56,
    height: 5.24
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_ui-design-26",
    x: 165.69,
    y: 348.29,
    width: 32.56,
    height: 5.24
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11_ui-design-26",
    x: 165.69,
    y: 381.96,
    width: 32.56,
    height: 5.24
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15_ui-design-26",
    x: 165.69,
    y: 415.63,
    width: 32.56,
    height: 5.24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "character_ui-design-26"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1_ui-design-26",
    d: "M167.48,164.69c1.27,1.46,2.5,3.29,4.41,3.6.6,0,1.2.14,1.75.37.76.47.85,1.52.87,2.39.11,3.94.21,7.88.31,11.81.06,2.21,0,4.64-1.43,6.3-.65.76-1.52,1.24-2.21,1.99-.76.69-.95,1.81-.47,2.71,3.84.01,7.65.74,11.22,2.16l-20.66.42c-.52.06-1.05-.04-1.52-.27-.71-.46-.81-1.43-.83-2.28-.08-3.38,0-6.75.18-10.12.22-2.24.25-4.49.11-6.73-.28-2.82-1.24-5.63-.7-8.41.87-4.48,5.32-8.11,8.95-3.93Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26_ui-design-26",
    d: "M137.39,226.28s-3.33.89-5.25-1.01c-1.92-1.9-.93-7.99-.93-7.99l34.48-41.81.68,11.75-28.98,39.06Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26_ui-design-26",
    d: "M184.33,227.57s5.11,7.07,8.39,7.24c3.28.17,23.05-35.01,23.05-35.01l4.33-3.33s-9.4-1.52-10.67.2c-1.27,1.72-15.87,25.8-15.87,25.8l-2.08-1.05-7.16,6.15Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24_ui-design-26",
    d: "M146.42,262.52s-1.52,9.68,0,13.66c1.52,3.98,14.87,27.76,14.87,27.76l-3.45,36.43h10.87l5.24-36.43-6-27.76,7.07-15.56-28.6,1.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24_ui-design-26",
    d: "M156.52,274.03l23.35,40.6,2.86,30.76,10.5-2.55-1.75-37.65-14.84-45.33-22.77,2.16s.56,8.68,2.64,12.01Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26_ui-design-26",
    d: "M184.22,345.04s1.23,7.94,1.79,8.51,4.96-.55,4.96-.55l7.28-4.7s0-2.28-5.48-.94c0,0-2.44.14-2.63-3.79l-5.93,1.47Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26_ui-design-26",
    d: "M168.72,340.31l-.76,3.63,6.22,4.35s-.25,1.15-2.45,1.65-12.01-.31-12.14-1.3,1.58-4.11,1.72-4.45.82-3.89.82-3.89h6.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27_ui-design-26 targetColor",
    d: "M154.6,195.24s-9.99,2.43-11.34,5.68c-1.35,3.25-12.32,13.39-12.04,17.39.27,4,7.79,9.15,7.79,9.15l5.75-5.61.65,37.9c.03,1.88,1.25,3.53,3.04,4.11,4.33,1.4,8.98,1.12,14.95-.85,8.49-2.81,13.45-2.53,13.45-2.53l-1.46-40.22,6.91,9,9.21-7.9s-13.53-22.01-15.84-23.37c-2.31-1.37-12.64-2.91-12.64-2.91,0,0-4.56,2.77-8.42.15Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25_ui-design-26",
    d: "M154.6,195.24s-9.99,2.43-11.34,5.68c-1.35,3.25-12.32,13.39-12.04,17.39.27,4,7.79,9.15,7.79,9.15l5.75-5.61.65,37.9c.03,1.88,1.25,3.53,3.04,4.11,4.33,1.4,8.98,1.12,14.95-.85,8.49-2.81,13.45-2.53,13.45-2.53l-1.46-40.22,6.91,9,9.21-7.9s-13.53-22.01-15.84-23.37c-2.31-1.37-12.64-2.91-12.64-2.91,0,0-4.56,2.77-8.42.15Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26_ui-design-26",
    d: "M167.58,172.92c.52,2.85.84,5.72.96,8.61.11,1.08.05,2.18-.18,3.24-.25,1.08-.98,1.98-1.98,2.44-.64.15-1.26.36-1.86.63-.44.32-.75.78-.88,1.31-.17,1-.17,2.03,0,3.04.16,1.01-.07,2.04-.63,2.9-.51.54-1.16.91-1.87,1.09-1.7.53-3.51.61-5.24.21-.27-.05-.53-.15-.76-.32-.24-.24-.41-.53-.49-.86-.63-1.94-1.14-3.92-1.52-5.92-.71-2.8-1.14-5.66-1.3-8.54-.15-2.9.6-5.78,2.14-8.24,1.62-2.39,4.42-4.09,7.3-3.9,1.6.2,3.16.67,4.6,1.4,1.19.58,1.46,1.61,1.72,2.91Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24_ui-design-26",
    d: "M167.58,168.98c.08-1.43-1.06-2.63-2.21-3.49-.22-.14-.41-.32-.57-.52-.16-.32-.28-.65-.36-1-.46-1.31-2.01-1.89-3.4-1.89s-2.75.42-4.13.38c-1.09,0-2.28-.33-3.25.13-.58.31-1.07.76-1.43,1.3-.69.8-1.18,1.75-1.41,2.78-.05.46-.11.93-.2,1.39-.16.51-.42.99-.76,1.4-1.44,1.98-3.54,3.64-4.06,6.03-.33,1.52-.65,3.26.08,4.63,7.07,13.15,8.86,13.91,9.61,13.78s4.72-.29,5.14-5.31c.1-.34.13-.69.1-1.04-.1-.29-.27-.55-.49-.76-.5-.49-.92-1.07-1.23-1.7-.32-.64-.32-1.39,0-2.03.55-.82,1.67-1.04,2.5-.49,0,0,0,0,0,0,.13.08.24.18.34.3.47-1.34-.93-2.86-.35-4.17.34-.76,1.31-1.18,1.64-1.97.44-1.06-.35-2.53.49-3.32.28-.2.58-.37.9-.51.48-.3.58-.69.81-1.15s.3-.42.8-.68c.81-.4,1.35-1.19,1.43-2.09Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_ui-design-26",
    d: "M209.09,203.69c-1.67,3.79-5.22,7.35-7.7,10.67-3.04,4.09-6.12,8.17-9.25,12.23-.27.4-.63.75-1.03,1.02-1.46.83-3.16-.55-4.23-1.84-6.1-7.37-10.81-15.79-13.89-24.85-.21-.44-.24-.95-.1-1.42.31-.68,1.24-.76,2-.76,9.41.26,18.82.57,28.23.95,3.23.14,7.97-.55,5.98,4Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24_ui-design-26",
    d: "M186.61,349.19c1.57-.38,2.52-1.95,3.84-2.89.31-.23.66-.4,1.04-.48.43-.03.86-.01,1.29.06,1.1.1,2.2-.15,3.31-.15.55,0,1.1.06,1.63.18.57.1,1.09.37,1.52.76.43.4.57,1.03.34,1.58-.18.31-.45.57-.76.76-2.53,1.75-5.08,3.49-7.66,5.22-.76.57-1.61,1.02-2.5,1.33-.85.24-1.75.22-2.6-.05-.34-.09-.64-.28-.88-.54-.18-.24-.3-.52-.36-.81-.3-1.06-.87-2.6-.65-3.71.21-1.12,1.55-1.03,2.44-1.25Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24_ui-design-26",
    d: "M159.89,345.52l-.9,3.04c-.2.43-.2.93,0,1.36.25.29.6.47.98.52.89.25,1.8.42,2.72.52,1.4.1,2.8-.17,4.2-.13,1.59.05,3.19.49,4.72.08.93-.31,1.8-.77,2.57-1.37l1.46-1.01c.12-.06.22-.17.27-.3.05-.19-.1-.37-.25-.5-1.11-.96-2.64-1.21-4.01-1.75-1.25-.49-2.38-1.25-3.32-2.21-.18-.23-.42-.39-.7-.48-.46-.09-.85.3-1.24.55-.8.43-1.72.59-2.62.46-.68-.1-.7-.45-1.12-.89-1.31-1.34-2.46,1.08-2.76,2.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/Design.302a68275eb31fd97fa1e87b04f1256f.svg";
export { ForwardRef as ReactComponent };